import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar";
import { LanguageProvider } from "./components/idiomas";

// Importar los componentes directamente
import HomePage from "./pages/home";
import ServicesPage from "./pages/services";
import TeamPage from "./pages/team";
import ContactPage from "./pages/contact";


function App() {
  return (
    <LanguageProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
